import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import Spinner from "../Loader/Spinner";
import PieChart from "./PieChart";
import SalePrice from "./SalePrice";
import {
  checkTimeDifference,
  convertAndCalcTimeDiff,
  preSaleTime,
} from "utils/time";
import BeforePreSale from "./BeforePreSale";
import SoldOut from "./SoldOut";
import * as icon from "services/icon";

const nSecondInMiliseconds = 1000;

const Presale = () => {
  const [timerCount, setTimerCount] = useState(
    convertAndCalcTimeDiff(
      import.meta.env.VITE_PRE_SALE_DATE,
import.meta.env.VITE_PRE_SALE_TIME
    )
  );
  const [individualReserve, setIndividualReserve] = useState(0);
  const [totalReserve, setTotalReserve] = useState(0);
  const [totalSale, setTotalSale] = useState(0);
  const [reserveTimeCount, setReserveTimeCount] = useState(0);
  const [preSaleTimeCount, setPreSaleTimeCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [preSaleEndDate, setPreSaleEndDate] = useState("");
  const [startPreSaleTimer, setStartPreSaleTimer] = useState(false);
  const [startReserveTimer, setStartReserverTimer] = useState(false);

  const address = useSelector((state) => state.wallet.walletAddress);

  let interval;
  let reserveInterval;
  let preSaleInterval;

  const getReserve = async () => {
    const getReserveInfo = await icon.getUserReservationInfo(address);

    setIndividualReserve(parseInt(getReserveInfo));
  };

  const reservationInfo = async () => {
    const getReservationInfo = await icon.getReservationInfo();
    const a = parseInt(getReservationInfo.reservationEndTime) / Math.pow(10, 6);

    const aa = moment.unix(a).utc().format("YYYY/MM/DD, HH:mm:ss");

    const [date, time] = aa.split(",");

    setReserveTimeCount(convertAndCalcTimeDiff(date, time));
    setStartReserverTimer(true);

    setTotalReserve(parseInt(getReservationInfo.totalReservation));
  };

  const preSaleDate = async () => {
    const { presaleEndDate } = await icon.getPresaleDate();

    const parsePreSaleTime = parseInt(presaleEndDate) / Math.pow(10, 6);

    const momentTime = moment
      .unix(parsePreSaleTime)
      .utc()
      .format("YYYY/MM/DD, HH:mm:ss");

    const [date, time] = momentTime.split(",");

    const times = moment
      .unix(parsePreSaleTime)
      .utc()
      .format("HH:mm:ss, dddd DD of MMM YYYY");

    setPreSaleEndDate(times);

    setPreSaleTimeCount(convertAndCalcTimeDiff(date, time));
    setStartPreSaleTimer(true);
  };

  useEffect(() => {
    preSaleDate();
  }, []);

  useEffect(() => {
    const getCount = async () => {
      setIsLoading(true);
      const count = await icon.getNftsold();

      setTotalSale(count);
      setIsLoading(false);
    };

    getCount();

    if (interval) {
      clearInterval(interval);
    }

    interval = setInterval(() => {
      if (timerCount === 0 && interval) {
        clearInterval(interval);
      }

      setTimerCount(
        (currentTimerCount) => currentTimerCount - nSecondInMiliseconds
      );
    }, nSecondInMiliseconds);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!startReserveTimer) return;
    if (reserveInterval) {
      clearInterval(reserveInterval);
    }

    reserveInterval = setInterval(() => {
      if (reserveTimeCount === 0 && reserveInterval) {
        clearInterval(reserveInterval);
      }

      setReserveTimeCount(
        (currentTimerCount) => currentTimerCount - nSecondInMiliseconds
      );
    }, nSecondInMiliseconds);

    return () => clearInterval(reserveInterval);
  }, [startReserveTimer]);

  useEffect(() => {
    if (!startPreSaleTimer) return;
    if (preSaleInterval) {
      clearInterval(preSaleInterval);
    }

    preSaleInterval = setInterval(() => {
      if (preSaleTimeCount === 0 && preSaleInterval) {
        clearInterval(preSaleInterval);
      }

      setPreSaleTimeCount(
        (currentTimerCount) => currentTimerCount - nSecondInMiliseconds
      );
    }, nSecondInMiliseconds);

    return () => clearInterval(preSaleInterval);
  }, [startPreSaleTimer]);

  useEffect(() => {
    if (address) {
      getReserve();
    } else {
      setIndividualReserve(0);
    }
    reservationInfo();
  }, [address]);

  const handleReserve = () => {
    getReserve();
    reservationInfo();
  };

  return (
    <>
      {isLoading ? (
        <>
          <Spinner className={"white"} />
        </>
      ) : (
        <>
          {totalSale === 5555 ? (
            <>{/* <SoldOut totalSold={totalSale} /> */}</>
          ) : (
            <>
              <div className="presale-text container" id="buy-gangsta">
                <h4 className=" pre-sale-time text-center align-self-center">
                  {!checkTimeDifference(timerCount)
                    ? `Starts in : ${preSaleTime(timerCount)}`
                    : !checkTimeDifference(preSaleTimeCount)
                    ? `Sale ends in: ${preSaleTime(preSaleTimeCount)}`
                    : ""}
                </h4>
                <div className="box" style={{ width: "100%" }}>
                  <div className="container">
                    <div className="row p-2 p-sm-4">
                      <div className="col-lg-4 pb-4 pb-lg-0 align-self-center position-relative">
                        {totalSale !== 5555 && (
                          <PieChart
                            preSaleStarted={checkTimeDifference(timerCount)}
                            checkPreSaleEndDate={checkTimeDifference(
                              preSaleTimeCount
                            )}
                          />
                        )}
                      </div>
                      <div
                        className={`${
                          totalSale !== 5555 ? "col-lg-8" : "col-lg-12"
                        } position-relative`}
                      >
                        <SalePrice
                          totalReserve={totalReserve}
                          indvidualReserve={individualReserve}
                          preSaleStarted={checkTimeDifference(timerCount)}
                          reloadReservation={handleReserve}
                          checkReserveEndDate={checkTimeDifference(
                            reserveTimeCount
                          )}
                          checkPreSaleEndDate={checkTimeDifference(
                            preSaleTimeCount
                          )}
                          preSaleEndDate={preSaleEndDate}
                        />
                        <BeforePreSale
                          totalReserve={totalReserve}
                          indvidualReserve={individualReserve}
                          preSaleStarted={checkTimeDifference(timerCount)}
                        />
                        {/* <img
                  src={DOTTED_LINE.SOURCE}
                  alt="dotted-line"
                  className="dotted-line horizontal"
                /> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default Presale;
